__turbopack_context__.v({
  "icon": "QpF6Nq_icon",
});
